export default __webpack_public_path__ + "static/media/no_results.c5ad2781.png";